const pkg = require('../../package.json');
const Footer = () => {

    return (
        <div className="mt-2">
            <p style={{ marginBottom: "3px", fontSize: "11px" }} id="PoweredByBihamta"></p>
            <p style={{ marginBottom: "3px", fontSize: "11px" }} id="PoweredByHoormah"></p>
            <p style={{ marginBottom: "3px", fontSize: "11px" }}>شماره نسخه:{pkg.version}</p>
        </div>
    )

}

export default Footer;